import { render } from "./OperationsPanel.vue?vue&type=template&id=52d1a380&scoped=true"
import script from "./OperationsPanel.vue?vue&type=script&lang=js"
export * from "./OperationsPanel.vue?vue&type=script&lang=js"

import "./OperationsPanel.vue?vue&type=style&index=0&id=52d1a380&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-52d1a380"]])

export default __exports__